import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import { useNavigate } from "react-router-dom";
import Spinner from "../img/loading.mp4";
import config from "../config.js";
import ModalRejoinBlocked from "./Modal/ModalRejoinBlocked.jsx";
import { clearSignupAttribution } from "../utils/attribution.js";
import { isWithdrawnUserCallback } from "../utils/oauthError.js";
import {
  completeGuestChatHandoff,
  hasPendingGuestChatHandoff,
} from "../utils/guestChatHandoff.js";

const AppleRedirect = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (isWithdrawnUserCallback(params)) {
      setShowModal(true);
      return;
    }
    if (params.get("status") === "error") {
      window.alert(
        `로그인에 실패했습니다: ${params.get("message") || "알 수 없는 오류"}`
      );
      navigate("/", { replace: true });
      return;
    }

    const checkLoginStatus = async () => {
      try {
        const response = await fetch(`${config.serverUri}/private/users/info`, {
          credentials: "include",
        });
        if (!response.ok) {
          navigate("/", { replace: true });
          return;
        }
        clearSignupAttribution();
        sessionStorage.removeItem("referralCode");
        const hadPendingHandoff = hasPendingGuestChatHandoff();
        if (hadPendingHandoff) {
          await completeGuestChatHandoff().catch((error) => {
            console.error("비로그인 채팅 이어가기 실패:", error);
          });
          navigate("/main", { replace: true });
          return;
        }
        const hasSeenGuide = localStorage.getItem("hasSeenAppGuide");
        navigate(hasSeenGuide === "true" ? "/main" : "/app-guide", {
          replace: true,
        });
      } catch (error) {
        console.error("애플 로그인 상태 확인 실패:", error);
        navigate("/", { replace: true });
      }
    };
    checkLoginStatus();
  }, [navigate]);

  return (
    <>
      <Wrapper>
        <ResponsiveVideo autoPlay loop muted playsInline>
          <source src={Spinner} type="video/mp4" />
        </ResponsiveVideo>
        <Text>
          <Highlight>로그인하는중</Highlight>
          <br />
          잠시만 기다려주세요
        </Text>
      </Wrapper>
      <ModalRejoinBlocked
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-weight: 500;
  overflow: hidden;
`;

const Text = styled.div`
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 60px;

  @media (max-width: 599px) {
    font-size: 14px;
    line-height: 32px;
  }
`;

const Highlight = styled.span`
  font-size: 48px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.8);

  @media (max-width: 599px) {
    font-size: 24px;
    line-height: 23px;
  }
`;

const ResponsiveVideo = styled.video`
  width: 320px;
  height: 320px;

  @media (max-width: 599px) {
    width: 150px;
    height: 150px;
  }
`;

export default AppleRedirect;
